<script lang="ts">
  import Card, { Content } from '@smui/card';
  import { onMount } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import {
    getBackgroundColor,
    getComingSoonDateFormat,
    getLabelColor,
    getStr,
    isDirectionRTL,
  } from '../../../common/util';
  import PrivacyPolicyCheckbox from '../../common/components/PrivacyPolicyCheckbox.svelte';
  import { notifyAlert } from '../../product-details/services/pdp-data-services';
  import Text from './../../common/components/Text.svelte';
  import PdpButton from './PdpButton.svelte';
  import StockTag from './StockTag.svelte';

  const rtl = isDirectionRTL();
  const { lang, CSRFToken, regexEmail, countryCallingCode, userDefaultCityCode, userSelectedCityCode, pdplAvailable } =
    getAppConfig();
  export let data: any;
  export let inStock = false;
  // export let isComingSoon;
  // export let comingSoonDate;
  // export let code;
  // export let nameEn;
  // export let price;
  const productCode = data?.code;
  let emailOrMobileNo = '';
  let inputEmpty = false;
  let invalidEmail = false;
  let invalidMobile = false;
  let emailAlreadyExists = false;
  let showSuccessMsg = false;
  const alertTypeLabel = data?.isComingSoon ? 'COMING_SOON' : 'STOCK';
  const emailAlreadyExistsMessage = getStr('extra.pdp.emailAlreadyExists');

  function emailOrMobileNoChange() {
    emailOrMobileNo = emailOrMobileNo.replace(countryCallingCode, '');
    //commented mobile number validation for April 1st
    // if((/^\d+$/.test(emailOrMobileNo))){
    //     emailOrMobileNo=countryPhoneNumberCode+emailOrMobileNo;
    // }
  }

  function stockAlertApi() {
    inputEmpty = false;
    invalidEmail = false;
    invalidMobile = false;
    let email = '';
    const mobileNo = '';
    const alertType = alertTypeLabel;
    const city = userSelectedCityCode || userDefaultCityCode;
    if (emailOrMobileNo == '') {
      inputEmpty = true;
    } else {
      var regEmail = new RegExp(regexEmail);

      if (!regEmail.test(emailOrMobileNo)) {
        invalidEmail = true;
      } else {
        email = emailOrMobileNo;
      }
      //Comment the mobile validation code for April 1st
      // if (!regMobile.test(mobileNumber)) {
      //     invalidMobile = true;
      // } else {
      //     mobileNo = mobileNumber;
      // }
    }

    if (inputEmpty == false && !invalidEmail) {
      notifyAlert({
        email,
        mobileNo,
        alertType,
        productCode,
        CSRFToken,
        city,
      })
        .then(response => {
          emailAlreadyExists = false;
          if (response.success) {
            showSuccessMsg = true;
            window['ACC'].mixpanel.trackNotifyMe(productCode, data?.nameEn, data?.price, false);
          } else {
            if (response.errorMessage) {
              emailAlreadyExists = true;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  const notifymebutton = getStr('extra.notifymebutton');
  const availableFrom = getStr('extra.pdp.availableFrom');
  const thankyou = getStr('extra.pdp.thankyou');
  const youWillHearSoon = getStr('extra.pdp.youWillHearSoon');
  const notifyMelabelColor = getLabelColor('extra.notifymebutton');
  const notifyMeBackgroundColor = getBackgroundColor('extra.notifymebutton');
  const EmailPlaceholder = getStr('extra.emailplaceholder');
  const enterValidEmail = getStr('extra.entervalidemail');
  const provideEmail = getStr('extra.pdp.provideEmail');
  let isPolicyChecked = true;

  onMount(() => document.documentElement.style.setProperty('--notifyMelabelColor', notifyMelabelColor));
  onMount(() => document.documentElement.style.setProperty('--notifyMeBackgroundColor', notifyMeBackgroundColor));

  function handlePolicyChange(event) {
    isPolicyChecked = event.detail;
  }
</script>

<div class="product-outof-stock-container card-display" class:rtl>
  <div class="card-container">
    <Card>
      {#if data?.isComingSoon}
        <div class="c_prodavailabledetails">
          <div class="d-flex out-of-stock-container">
            <div class="mdc-typography--subtitle2">
              <Text key="extra.soonmessage" />
            </div>
          </div>
          {#if data?.comingSoonDate != null}
            <div class="product-status-text">
              {availableFrom}
              {getComingSoonDateFormat(data?.comingSoonDate, lang)}
            </div>
          {/if}
        </div>
      {:else}
        <div class="c_prodavailabledetails">
          <div class="d-flex out-of-stock-container">
            <div class="mdc-typography--subtitle2">
              <Text key="extra.uhno" />
            </div>
            <StockTag stockFlag={inStock} stockStatus={null} stockCount={null} />
          </div>
          <div class="product-status-text">
            <Text key="extra.pdp.unavailable.product" />
          </div>
        </div>
      {/if}
      <Content class="mdc-typography--body2">
        {#if !showSuccessMsg}
          <form on:submit|preventDefault={stockAlertApi}>
            {#if data?.isComingSoon}
              <p class="notify-info-text">
                <Text key="extra.notifymesoonmessage" />
              </p>
            {:else}
              <p class="notify-info-text">
                <Text key="extra.notifymsg" />
              </p>
            {/if}
            <input
              type="text"
              bind:value={emailOrMobileNo}
              name="notifyStockInput"
              id="notifyStockInput"
              class={inputEmpty || (invalidEmail && invalidMobile)
                ? 'form-control-input form-error'
                : 'form-control-input '}
              placeholder={EmailPlaceholder}
              on:input={() => emailOrMobileNoChange()}
            />
            {#if inputEmpty}
              <p class="error-message">{provideEmail}</p>
            {/if}
            {#if invalidEmail || invalidMobile}
              <p class="error-message">{enterValidEmail}</p>
            {/if}
            {#if emailAlreadyExists}
              <p class="error-message">
                {emailAlreadyExistsMessage}
              </p>
            {/if}
            <!-- isPolicyChecked checkbox -->
            {#if pdplAvailable}
              <PrivacyPolicyCheckbox {isPolicyChecked} on:policyChange={handlePolicyChange} />
            {/if}

            <span class={`${notifyMelabelColor && 'notifyMeBtnLbl'} ${notifyMeBackgroundColor && 'notifyMeBtnBg'}`}>
              <PdpButton
                label={notifymebutton}
                type="primary"
                size="large"
                variant="solid"
                disabled={!isPolicyChecked}
              /></span
            >
          </form>
        {/if}
        {#if showSuccessMsg}
          <div class="alert-info-container">
            <Card variant="outlined" padded>
              <p class="thank-text">{thankyou}</p>
              <p class="content">
                {youWillHearSoon} <br />
                <!--commenting this part as per MAVD-6302
                         {listedSome}
                        <a href="#" class="link">{similarProduct}</a> {youMightLike} -->
              </p>
            </Card>
          </div>
        {/if}
      </Content>
    </Card>
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .card-display {
    margin-top: 42px;
    padding: 0 16px;
    @include desktop-min-width {
      margin-top: 24px;
      padding: 0;
      padding-right: 48px;
    }
  }
  .out-of-stock-container {
    align-items: center;
    justify-content: space-between;
    padding-bottom: 4px;
    @include desktop-min-width {
      padding-bottom: 8px;
    }
  }
  .mdc-typography--subtitle2 {
    color: $neutral-dark-02;
    font-size: 16px;
    font-weight: 400;
    line-height: 18px;
  }
  .product-status-text {
    color: $neutral-dark-01;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 24px;
    @include desktop-min-width {
      font-size: 36px;
      line-height: 40px;
      margin-bottom: 48px;
    }
  }
  .notify-info-text {
    padding: 0 0 8px 0;
    margin: 0;
    font-weight: 400;
  }
  .form-control-input {
    border: 1.4px solid $secondary-gray-01;
    border-radius: 5px;
    color: $neutral-dark-01;
    padding: 8px 16px;
    width: 100%;
    height: 48px;
    font-size: 14px;
    font-weight: 400;
    &.form-error {
      border: 1.4px solid $error-red;
    }
    &::placeholder {
      color: $secondary-gray-01;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
    }
    @include desktop-min-width {
      font-size: 16px;
      padding: 14px 16px;
      line-height: 18px;
      border-radius: 8px;
      &::placeholder {
        font-size: 16px;
      }
    }
  }
  .error-message {
    color: $error-red;
    font-size: 14px;
    padding: 10px 0 0 0;
    margin: 0;
  }
  .bottom-links {
    display: flex;
    justify-content: center;
    padding: 16px 0 24px 0;
    .action-links {
      color: $icon-only-icon-blue;
      cursor: pointer;
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      padding-right: 18px;
    }
    .fav-wrapper {
      display: flex;
      align-items: center;
    }
    @include desktop-min-width {
      padding: 33px 0 51px 0;
      .action-links {
        font-size: 16px;
        line-height: 18px;
        // padding-right: 40px;
      }
    }
  }
  .card-display.rtl {
    @include desktop-min-width {
      padding-right: 0px;
      // padding-left: 48px;
    }
  }

  :global {
    .product-outof-stock-container .mdc-card {
      background-color: $primary-white !important;
      box-shadow: none;
    }
    .card-container {
      .alert-info-container {
        .mdc-card.mdc-card--outlined {
          padding: 21px 16px;
          border: 1px solid $secondary-gray-02;
          background: $neutral-light-04 !important;
          .thank-text {
            font-size: 24px;
            line-height: 28px;
            font-weight: 700;
            margin: 0 0 12px 0;
            color: $neutral-dark-01;
          }
          .content {
            font-size: 16px;
            line-height: 18px;
            margin: 0;
            color: $neutral-dark-02;
          }
          .link {
            color: $icon-only-icon-blue;
            text-decoration: none;
          }
        }
      }

      .tag {
        white-space: nowrap;
      }
      .mdc-card {
        box-shadow: none;
      }

      .smui-card__content {
        padding: 0;
      }

      .mdc-typography--body2 .extra-btn-solid--color-primary {
        border-radius: 30px;
        width: 100%;
        height: 48px !important;
        margin-top: 8px;
        text-align: center;
        @include desktop-min-width {
          border-radius: 100px;
          margin-top: 20px;
          height: 64px !important;
        }
      }

      .mdc-typography--body2 .extra-btn-solid--color-primary span {
        font-size: 16px;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        @include desktop-min-width {
          font-size: 24px;
          line-height: 28px;
        }
      }
    }
  }
  :global {
    .notifyMeBtnLbl {
      .mdc-button--raised {
        color: var(--notifyMelabelColor) !important;
      }
    }
    .notifyMeBtnBg {
      .mdc-button--raised {
        background-color: var(--notifyMeBackgroundColor) !important;
      }
    }
  }
</style>
